import React from 'react'
import { Button, Modal, ModalInjectedProps, Text } from '@sketch/components'
import { useDeletePermissionGroupMutation } from '@sketch/gql-types'
import { useToast } from '@sketch/toasts'
import { removeFromPaginated } from '@sketch/modules-common'
import PermissionGroupMemberTable from 'modules/workspace/components/PermissionGroupMemberTable/PermissionGroupMemberTable'

interface DeletePermissionGroupModalProps extends ModalInjectedProps {
  permissionGroupIdentifier: string
  permissionGroupName: string
}

const DeletePermissionGroupModal = (props: DeletePermissionGroupModalProps) => {
  const { permissionGroupIdentifier, permissionGroupName, hideModal } = props

  const { showToast } = useToast()
  const [deleteGroup, { loading }] = useDeletePermissionGroupMutation({
    variables: { input: { permissionGroupIdentifier } },
    onError: 'show-toast',
    onCompleted: () => {
      showToast('Permission group has been deleted!')
      hideModal()
    },
    update: cache => {
      removeFromPaginated(
        cache,
        {
          __typename: 'PermissionGroup',
          identifier: permissionGroupIdentifier,
        },
        () => true
      )
    },
  })

  return (
    <Modal onCancel={hideModal}>
      <Modal.Header>Delete Group?</Modal.Header>
      <Modal.Body>
        <Text>
          If you delete the “<b>{permissionGroupName}</b>” group its Members
          will no longer have access to its projects and documents. You can’t
          undo this action.
        </Text>

        <PermissionGroupMemberTable
          permissionGroupIdentifier={permissionGroupIdentifier}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={hideModal}>Cancel</Button>
        <Button
          onClick={() => deleteGroup()}
          variant="negative"
          loading={loading}
        >
          Delete Group
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DeletePermissionGroupModal
